import { Badge } from '@@/Badge';

export function SettingItem({
  label,
  value,
}: {
  label: string;
  value: boolean | undefined;
}) {
  return (
    <div className="flex items-center justify-between border-b border-gray-5 bg-gray-2 px-4 py-3 last:border-b-0 th-dark:border-gray-7 th-dark:bg-gray-iron-10">
      <span className="text-sm">{label}</span>
      <Badge type={value ? 'success' : 'muted'}>
        {value ? 'Enabled' : 'Disabled'}
      </Badge>
    </div>
  );
}
